const ShippingInfoBranchCardSkeleton = ({ fromPDP = false }) => {
  if (fromPDP) {
    return (
      <div className='border-border mb-4 animate-pulse rounded-lg border p-4 max-sm:p-2'>
        <div className='flex items-start justify-between gap-3'>
          <div className='flex w-full flex-col gap-1'>
            <div className='flex items-center gap-4'>
              <div className='h-4 w-32 rounded bg-gray-200' />

              <div className='h-4 w-24 rounded bg-gray-200' />

              <div className='h-4 w-20 rounded bg-gray-200' />
            </div>

            <div className='h-3 w-40 rounded bg-gray-200' />

            <div className='h-3 w-32 rounded bg-gray-200' />
          </div>

          <div className='border-border rounded-lg border px-3 py-1.5 text-[11px] font-medium'>
            <div className='h-3 w-14 rounded bg-gray-200' />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className='border-border mb-4 animate-pulse rounded-2xl border p-4 max-sm:p-2'>
      <div className='flex items-start justify-between gap-3'>
        <div className='flex w-full flex-col gap-2'>
          <div className='h-4 w-32 rounded bg-gray-200' />

          <div className='flex items-center gap-2'>
            <div className='h-3 w-40 rounded bg-gray-200' />
            <div className='h-4 w-16 rounded bg-gray-300' />
          </div>

          <div className='mt-1 h-3 w-24 rounded bg-gray-200' />
        </div>

        <div className='flex flex-col items-end gap-2'>
          <div className='h-5 w-20 rounded-full bg-gray-200 max-sm:w-15' />

          <div className='h-7 w-16 rounded-lg bg-gray-100' />
        </div>
      </div>
    </div>
  );
};

export default ShippingInfoBranchCardSkeleton;
